import { navigate } from "vike/client/router";

/**
 * Replacement for react-router's useNavigate().
 * Returns a navigate function compatible with the old API.
 */
export function useNavigate() {
  return (to: string) => {
    navigate(to);
  };
}
